import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import {
  POSTHOG_FEATURE_FLAGS,
  usePostHogFeatureFlag
} from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'

const ALL_ROUTE = '/validation-submissions'
const HELD_ROUTE = '/validation-submissions/holds'
// The All tab lands where the Verifications menu item does: pending first, oldest first.
const ALL_LANDING = `${ALL_ROUTE}?statuses=pending&sort=id&direction=ASC`

/**
 * The All / Held tabs across the top of the verifications list, as props for `Table`. Held is the
 * only other tab, so without the holds flag there is nothing to switch between and no tabs at all.
 */
export function useVerificationTabs() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const holdsEnabled = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_VALIDATION_SUBMISSION_HOLDS)

  if (!holdsEnabled) {
    return {}
  }

  const active = pathname === HELD_ROUTE ? HELD_ROUTE : ALL_ROUTE

  return {
    items: [
      { key: ALL_ROUTE, label: t('table.all') },
      { key: HELD_ROUTE, label: t('table.held') }
    ],
    active,
    onChangeTab: (tab: string) => {
      if (tab !== active) {
        navigate(tab === HELD_ROUTE ? HELD_ROUTE : ALL_LANDING)
      }
    }
  }
}
